import React from "react"
import RPMCriticalTimePassed from "./RPMCriticalTimePassed"

const RPMCriticalTimePassedPatientScreen = () => <RPMCriticalTimePassed />

export default RPMCriticalTimePassedPatientScreen
